<template>
    <div class="container">
        <h2>Admin Calderas</h2>
        <v-divider></v-divider>
    </div>
</template>
<script>
export default {
    data: () => ({
        settings:{
            columns:[
                {header:''}
            ],
            actions:[]
        }
  }),
}
</script>